import React from 'react';
import './IconButton.css';

export type IconButtonVariant = 'default' | 'delete';

export interface IconButtonProps {
	onClick: () => void;
	ariaLabel: string;
	tooltip?: string;
	variant?: IconButtonVariant;
	showBorder?: boolean;
	className?: string;
	children: React.ReactNode;
}

export const IconButton: React.FC<IconButtonProps> = ({
	onClick,
	ariaLabel,
	tooltip,
	variant = 'default',
	showBorder = true,
	className = '',
	children,
}) => {
	const classes = [
		'icon-button',
		`icon-button-${variant}`,
		!showBorder && 'icon-button-borderless',
		className,
	]
		.filter(Boolean)
		.join(' ');

	return (
		<button
			className={classes}
			onClick={onClick}
			aria-label={ariaLabel}
			title={tooltip || ariaLabel}
		>
			{children}
		</button>
	);
};
